// 在limit时间内连续触发超过MaxEmit，则触发callback
const MaxEmit = 1;

export const throttle = (
  func: Function,
  limit: number,
  callback?: Function,
  callbackFinish?: () => void
): Function => {
  let inThrottle: boolean;
  let emitCount = 0;

  return function (this: any, ...args: any[]): any {
    if (!inThrottle) {
      inThrottle = true;
      emitCount = 0;
      func.apply(this, args);
      setTimeout(() => {
        inThrottle = false;
        callbackFinish && callbackFinish();
      }, limit);
    } else {
      emitCount++;
      if (emitCount >= MaxEmit && callback) {
        callback();
        emitCount = 0;
      }
    }
  };
};

export const debounce = (callback: Function, limit: number) => {
  let timer: NodeJS.Timeout;

  return function (this: any, ...args: any[]) {
    if (timer !== null) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      callback.apply(this, args);
    }, limit);
  };
};
